import { memo } from "react";
import logger from "../../Utils/logger";

/**
 * Dynamically import all files in a directory.
 *
 * @param {__WebpackModuleApi.RequireContext} context - require.context() result
 * @returns {Record<string, string>} Object mapping clean names to imported image paths
 */

const normalizeKey = (key) =>
  key
    .replace(/[-_\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : "")) // kebab or snake to camelCase
    .replace(/\.(png|jpg|jpeg|gif|svg)$/i, "") // remove extensions
    .replace(/^.*[\\/]/, ""); // remove folder path

const importAll = (context, prefix = "") =>
  Object.fromEntries(
    context.keys().map((key) => {
      const fileName = key.replace(/^.*[\\/]/, "");
      const cleanKey = normalizeKey(prefix ? `${prefix}/${fileName}` : fileName);
      return [cleanKey, context(key)];
    }),
  );

// Automatically import assets
const assets = {
  general: importAll(require.context("../../Assets/img", false, /\.(png|jpg|jpeg)$/)),
};

// Manual overrides (for specific named files)
const manual = {
  logo: process.env.REACT_APP_LOGO,
};

// Merge all into one image registry
export const images = {
  ...assets.general,
  ...manual,
};

/**
 * ImageResource Component
 * - Supports both `marquee-1` and `marquee1`
 * - Warns if image not found
 */
logger.log("images", images);
const ImageResource = memo(({ type, alt = "", className = "", ...props }) => {
  const normalizedType = type;

  const src = images[normalizedType] || images[type];

  if (!src) {
    logger.warn(`⚠️ Image type "${type}" not found in ImageResource.`);
    return null;
  }

  return <img src={src} alt={alt} className={className} {...props} />;
});

export default ImageResource;
